const RBAC_SCOPE_STORAGE_KEYS = [
  'rbac_current_account_id',
  'rbac_selected_subtenant_id',
  'rbac_selected_subtenant_member_external_user_id',
  'rbac_selected_subtenant_member_rbac_user_id',
  'rbac_owner_account_id',
];

export function clearRBACScopeStorage() {
  if (typeof window === 'undefined') return;
  RBAC_SCOPE_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}
